var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"DarkRoom"}},[_c('b-container',{attrs:{"fluid":""}},_vm._l((_vm.darkroomsArray),function(darkroom){return _c('b-row',{key:darkroom.id},[_c('b-col',[_c('DarkRoomElement',{attrs:{"darkroom":darkroom}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }